import { render, staticRenderFns } from "./ReportTabs.vue?vue&type=template&id=746350e5"
import script from "./ReportTabs.vue?vue&type=script&lang=js"
export * from "./ReportTabs.vue?vue&type=script&lang=js"
import style0 from "./ReportTabs.vue?vue&type=style&index=0&id=746350e5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports